{
  "name": "@asm/licensing",
  "version": "1.0.0-SNAPSHOT",
  "dependencies": {
    "@angular/cdk": "^22.2.5",
    "@angular/common": "^22.2.4",
    "@angular/compiler": "^22.2.4",
    "@angular/core": "^22.2.4",
    "@angular/forms": "^22.2.4",
    "@angular/platform-browser": "^22.2.4",
    "@angular/router": "^22.2.4",
    "@asm/components-core": "workspace:*",
    "@asm/components-licensing": "workspace:*",
    "@asm/components-table": "workspace:*",
    "@sol/components": "workspace:*",
    "@sol/icons": "workspace:*",
    "@sol/theme": "workspace:*",
    "chart.js": "^4.6.1",
    "keycloak-angular": "^22.0.0",
    "keycloak-js": "^26.2.5",
    "rxjs": "~7.8.2",
    "tslib": "^2.9.1",
    "zone.js": "~0.16.3"
  },
  "devDependencies": {
    "@angular/build": "^22.2.5",
    "@angular/cli": "^22.2.5",
    "@angular/compiler-cli": "^22.2.4",
    "@asm/config": "workspace:1.0.0-SNAPSHOT",
    "@playwright/test": "1.63.0",
    "@types/jasmine": "~6.0.0",
    "@typescript-eslint/parser": "^8.72.1",
    "angular-eslint": "^22.6.0",
    "eslint": "^10.14.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.7",
    "jasmine-core": "~6.3.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.3.0",
    "prettier": "^3.9.10",
    "serve": "^14.2.6",
    "typescript": "~6.0.3"
  },
  "private": true,
  "scripts": {
    "ci:build:dit": "node ../asm-config/src/generate-configs.mjs && ng build --configuration dit",
    "ci:build:prod": "node ../asm-config/src/generate-configs.mjs && ng build --configuration prod",
    "ci:build:uat": "node ../asm-config/src/generate-configs.mjs && ng build --configuration uat",
    "ci:lint": "node ../asm-config/src/generate-configs.mjs && prettier --check src && eslint src --quiet",
    "ci:test": "node ../asm-config/src/generate-configs.mjs && NODE_OPTIONS=--max-old-space-size=6144 ng test --watch=false",
    "e2e": "node ../asm-config/src/generate-configs.mjs && playwright test",
    "lint": "node ../asm-config/src/generate-configs.mjs && prettier --write \"**/*.{ts,html,md,scss,json}\" && eslint src --fix --quiet",
    "logged": "../scripts/logged.sh",
    "ng": "node ../asm-config/src/generate-configs.mjs && ng",
    "start:dit": "node ../asm-config/src/generate-configs.mjs && ng serve --port 8088 --configuration dit",
    "start:sandbox": "node ../asm-config/src/generate-configs.mjs && ng serve --host 0.0.0.0 --port 8088 --configuration sandbox",
    "start:uat": "node ../asm-config/src/generate-configs.mjs && ng serve --port 8088 --configuration uat",
    "ci:build:sandbox": "node ../asm-config/src/generate-configs.mjs && ng build --configuration sandbox"
  }
}
